import React from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';

const CategoryNavigation = ({ selectedCategory, setSelectedCategory }) => {
  const categories = [
    { id: 'all', name: 'Alles', icon: 'Grid' },
    { id: 'energy-efficiency', name: 'Energie Efficiëntie', icon: 'Zap' },
    { id: 'renewable-energy', name: 'Hernieuwbare Energie', icon: 'Sun' },
    { id: 'insulation', name: 'Isolatie & Bouwen', icon: 'Home' },
    { id: 'water-management', name: 'Waterbeheer', icon: 'Droplets' },
    { id: 'subsidies', name: 'Subsidies & Regelingen', icon: 'Euro' }
  ];

  return (
    <section className="bg-card border-b border-border sticky top-16 lg:top-0 z-40">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex overflow-x-auto scrollbar-hide py-4 gap-2">
          {categories?.map((category) => (
            <motion.button
              key={category?.id}
              onClick={() => setSelectedCategory(category?.id)}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className={`flex items-center space-x-2 px-4 py-2 rounded-lg whitespace-nowrap transition-all ${
                selectedCategory === category?.id
                  ? 'bg-primary text-primary-foreground shadow-elevation-1'
                  : 'bg-muted/50 text-muted-foreground hover:bg-muted'
              }`}
            >
              <Icon name={category?.icon} size={18} />
              <span className="text-sm font-body font-medium">{category?.name}</span>
            </motion.button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CategoryNavigation;